import React, {FC} from 'react';

import {sortCustomAttributes} from '../../../../helpers/customFieldHelpers';
import {AccountAttributeUpdateAction} from '../../../../helpers/models/accountAttributeUpdateHelpers';
import {AccountModel} from '../../../../models/api/accountModel';
import {CrmSyncStatusesEnum} from '../../../../models/api/crmSyncModel';
import {CustomAttributeModel} from '../../../../models/api/customFieldModel';
import {AccountCustomAttribute} from './accountCustomAttribute';

/*
 * Props.
 */

interface AccountCustomAttributesProps {
  account: AccountModel;
  customAttributes: ReadonlyArray<CustomAttributeModel>;
  crmSyncEditLink?: string;
  crmSyncStatus?: CrmSyncStatusesEnum;
  crmSyncCustomFieldIds: ReadonlyArray<number>;
  shouldDisableActions?: boolean;
  updateAccountAttributeAsync: (action: AccountAttributeUpdateAction) => Promise<void>;
  updateUnsavedAccount: (action: AccountAttributeUpdateAction) => void;
}

/*
 * Component.
 */

export const AccountCustomAttributes: FC<AccountCustomAttributesProps> = (props) => {
  const {
    account,
    customAttributes,
    crmSyncEditLink,
    crmSyncStatus,
    crmSyncCustomFieldIds,
    shouldDisableActions,
    updateAccountAttributeAsync,
    updateUnsavedAccount,
  } = props;
  return (
    <>
      {sortCustomAttributes(customAttributes).map((customAttribute) => (
        <AccountCustomAttribute
          key={customAttribute.customField.id}
          accountId={account.id}
          customAttribute={customAttribute}
          crmSyncEditLink={crmSyncEditLink}
          crmSyncStatus={crmSyncStatus}
          isFieldCrmSyncing={crmSyncCustomFieldIds.includes(customAttribute.customField.id)}
          crmSyncSource={account.externalInfo?.source}
          shouldDisableActions={shouldDisableActions}
          updateAccountAttributeAsync={updateAccountAttributeAsync}
          updateUnsavedAccount={updateUnsavedAccount}
        />
      ))}
    </>
  );
};
